import { Component, OnInit } from '@angular/core';
import "@maersk-global/mds-components-core/mc-card";
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
@Component({
  selector: 'app-failed',
  templateUrl: './failed.component.html',
  styleUrls: ['./failed.component.scss']
})
export class FailedComponent implements OnInit {
  constructor(private router:Router, private authService:MsalService) {

  }

  ngOnInit(): void {
    const activeAccount = this.authService.instance.getActiveAccount();
    const allAccounts = this.authService.instance.getAllAccounts();

    if (!activeAccount && allAccounts.length > 0) {
      this.authService.instance.setActiveAccount(allAccounts[0]);
    }

    if (this.authService.instance.getAllAccounts().length > 0) {
      this.router.navigate(['/dashboard']);
    }
  }
  
} 
